// This file is auto-generated by @hey-api/openapi-ts

import { client, type Options } from '@hey-api/client-fetch';
import type {
  GetProxyUserExternalReferencesData,
  GetProxyUserExternalReferencesError,
  GetProxyUserExternalReferencesResponse,
  UpdateProfilexUserExternalRefsData,
  UpdateProfilexUserExternalRefsError,
  UpdateProfilexUserExternalRefsResponse,
  CreateProfilexUserExternalRefsData,
  CreateProfilexUserExternalRefsError,
  CreateProfilexUserExternalRefsResponse,
  DeleteProxyUserExternalReferencesData,
  DeleteProxyUserExternalReferencesError,
  DeleteProxyUserExternalReferencesResponse,
  GetPropertyData,
  GetPropertyError,
  GetPropertyResponse,
  PutPropertyData,
  PutPropertyError,
  PutPropertyResponse,
  DeletePropertyData,
  DeletePropertyError,
  DeletePropertyResponse,
  GetUserData,
  GetUserError,
  GetUserResponse,
  UpdateUserData,
  UpdateUserError,
  UpdateUserResponse,
  GetUserMeData,
  GetUserMeError,
  GetUserMeResponse,
  UpdateUserMeData,
  UpdateUserMeError,
  UpdateUserMeResponse,
  GetProxyUserMeExternalReferencesError,
  GetProxyUserMeExternalReferencesResponse,
  UpdateProfilexUserExternalRefs1Data,
  UpdateProfilexUserExternalRefs1Error,
  UpdateProfilexUserExternalRefs1Response,
  CreateProfilexUserExternalRefs1Data,
  CreateProfilexUserExternalRefs1Error,
  CreateProfilexUserExternalRefs1Response,
  DeleteProxyUserMeExternalReferencesError,
  DeleteProxyUserMeExternalReferencesResponse,
  ListPropertiesData,
  ListPropertiesError,
  ListPropertiesResponse,
  PostPropertyData,
  PostPropertyError,
  PostPropertyResponse,
  GetUserRoleData,
  GetUserRoleError,
  GetUserRoleResponse,
  CreateUserRoleData,
  CreateUserRoleError,
  CreateUserRoleResponse,
  DeleteUserRoleData,
  DeleteUserRoleError,
  DeleteUserRoleResponse,
  GetBulkUsersByUuidData,
  GetBulkUsersByUuidError,
  GetBulkUsersByUuidResponse,
  GetBulkUsersByEmailData,
  GetBulkUsersByEmailError,
  GetBulkUsersByEmailResponse,
  GetBulkUsersData,
  GetBulkUsersError,
  GetBulkUsersResponse,
  GetUserExternalReferencesData,
  GetUserExternalReferencesError,
  GetUserExternalReferencesResponse,
  DeleteUserExternalReferencesData,
  DeleteUserExternalReferencesError,
  DeleteUserExternalReferencesResponse,
  GetUserPreferenceData,
  GetUserPreferenceError,
  GetUserPreferenceResponse,
  GetUserImageData,
  GetUserImageError,
  GetUserImageResponse,
  GetUserByTrnData,
  GetUserByTrnError,
  GetUserByTrnResponse,
  GetUserExternalReferences1Data,
  GetUserExternalReferences1Error,
  GetUserExternalReferences1Response,
  DeleteUserMeExternalReferencesData,
  DeleteUserMeExternalReferencesError,
  DeleteUserMeExternalReferencesResponse,
  GetUserByUuidOrEmailData,
  GetUserByUuidOrEmailError,
  GetUserByUuidOrEmailResponse,
} from './types.gen';

/**
 * Get User External References
 * Get list of user External References by trn
 */
export const getProxyUserExternalReferences = (
  options: Options<GetProxyUserExternalReferencesData>
) => {
  return (options?.client ?? client).get<
    GetProxyUserExternalReferencesResponse,
    GetProxyUserExternalReferencesError
  >({
    ...options,
    url: '/users/{userTrnId}/externalrefs',
  });
};

/**
 * Modify User External References
 * Update the external reference for the given trn
 */
export const updateProfilexUserExternalRefs = (
  options: Options<UpdateProfilexUserExternalRefsData>
) => {
  return (options?.client ?? client).put<
    UpdateProfilexUserExternalRefsResponse,
    UpdateProfilexUserExternalRefsError
  >({
    ...options,
    url: '/users/{userTrnId}/externalrefs',
  });
};

/**
 * Create User External References
 * Create a new user external reference based on trn
 */
export const createProfilexUserExternalRefs = (
  options: Options<CreateProfilexUserExternalRefsData>
) => {
  return (options?.client ?? client).post<
    CreateProfilexUserExternalRefsResponse,
    CreateProfilexUserExternalRefsError
  >({
    ...options,
    url: '/users/{userTrnId}/externalrefs',
  });
};

/**
 * Delete User External References
 * Delete the external reference for the given trn
 */
export const deleteProxyUserExternalReferences = (
  options: Options<DeleteProxyUserExternalReferencesData>
) => {
  return (options?.client ?? client).delete<
    DeleteProxyUserExternalReferencesResponse,
    DeleteProxyUserExternalReferencesError
  >({
    ...options,
    url: '/users/{userTrnId}/externalrefs',
  });
};

/**
 * Get property
 * Api to get property of user by uuid and key
 */
export const getProperty = (options: Options<GetPropertyData>) => {
  return (options?.client ?? client).get<GetPropertyResponse, GetPropertyError>(
    {
      ...options,
      url: '/users/{tidUuid}/properties/{key}',
    }
  );
};

/**
 * Upsert property
 * Api to create or update the property of a user by uuid and key
 */
export const putProperty = (options: Options<PutPropertyData>) => {
  return (options?.client ?? client).put<PutPropertyResponse, PutPropertyError>(
    {
      ...options,
      url: '/users/{tidUuid}/properties/{key}',
    }
  );
};

/**
 * Delete property
 * Api to delete user property by uuid and key
 */
export const deleteProperty = (options: Options<DeletePropertyData>) => {
  return (options?.client ?? client).delete<
    DeletePropertyResponse,
    DeletePropertyError
  >({
    ...options,
    url: '/users/{tidUuid}/properties/{key}',
  });
};

/**
 * Get User
 * Get user details by TC visible id
 */
export const getUser = (options: Options<GetUserData>) => {
  return (options?.client ?? client).get<GetUserResponse, GetUserError>({
    ...options,
    url: '/users/{id}',
  });
};

/**
 * Update user by Id
 * API to update current user details by id
 */
export const updateUser = (options: Options<UpdateUserData>) => {
  return (options?.client ?? client).put<UpdateUserResponse, UpdateUserError>({
    ...options,
    url: '/users/{id}',
  });
};

/**
 * Get User Me
 * Api to get the current user details
 */
export const getUserMe = (options?: Options<GetUserMeData>) => {
  return (options?.client ?? client).get<GetUserMeResponse, GetUserMeError>({
    ...options,
    url: '/users/me',
  });
};

/**
 * Update User me
 * API to update the current user details
 */
export const updateUserMe = (options: Options<UpdateUserMeData>) => {
  return (options?.client ?? client).put<
    UpdateUserMeResponse,
    UpdateUserMeError
  >({
    ...options,
    url: '/users/me',
  });
};

/**
 * Get User External References
 * Get list of current user External References
 */
export const getProxyUserMeExternalReferences = (options?: Options) => {
  return (options?.client ?? client).get<
    GetProxyUserMeExternalReferencesResponse,
    GetProxyUserMeExternalReferencesError
  >({
    ...options,
    url: '/users/me/externalrefs',
  });
};

/**
 * Modify User External References
 * Update the external reference for the current user
 */
export const updateProfilexUserExternalRefs1 = (
  options: Options<UpdateProfilexUserExternalRefs1Data>
) => {
  return (options?.client ?? client).put<
    UpdateProfilexUserExternalRefs1Response,
    UpdateProfilexUserExternalRefs1Error
  >({
    ...options,
    url: '/users/me/externalrefs',
  });
};

/**
 * Create User External References
 * Create a new user external reference based current user
 */
export const createProfilexUserExternalRefs1 = (
  options: Options<CreateProfilexUserExternalRefs1Data>
) => {
  return (options?.client ?? client).post<
    CreateProfilexUserExternalRefs1Response,
    CreateProfilexUserExternalRefs1Error
  >({
    ...options,
    url: '/users/me/externalrefs',
  });
};

/**
 * Delete User External References
 * Delete the external reference for the current trn
 */
export const deleteProxyUserMeExternalReferences = (options?: Options) => {
  return (options?.client ?? client).delete<
    DeleteProxyUserMeExternalReferencesResponse,
    DeleteProxyUserMeExternalReferencesError
  >({
    ...options,
    url: '/users/me/externalrefs',
  });
};

/**
 * List properties
 * Api to list all properties of user by uuid
 */
export const listProperties = (options: Options<ListPropertiesData>) => {
  return (options?.client ?? client).get<
    ListPropertiesResponse,
    ListPropertiesError
  >({
    ...options,
    url: '/users/{tidUuid}/properties',
  });
};

/**
 * Create property
 * Api to create a new property for user by uuid and key
 */
export const postProperty = (options: Options<PostPropertyData>) => {
  return (options?.client ?? client).post<
    PostPropertyResponse,
    PostPropertyError
  >({
    ...options,
    url: '/users/{tidUuid}/properties',
  });
};

/**
 * Get User Role by Uuid
 * Get roles of user by uuid
 */
export const getUserRole = (options: Options<GetUserRoleData>) => {
  return (options?.client ?? client).get<GetUserRoleResponse, GetUserRoleError>(
    {
      ...options,
      url: '/users/tid/{uuid}/roles',
    }
  );
};

/**
 * Create User Role by Uuid
 * Create user role mappings by uuid
 */
export const createUserRole = (options: Options<CreateUserRoleData>) => {
  return (options?.client ?? client).post<
    CreateUserRoleResponse,
    CreateUserRoleError
  >({
    ...options,
    url: '/users/tid/{uuid}/roles',
  });
};

/**
 * Delete User Role by uuid
 * Delete user role mappings by uuid
 */
export const deleteUserRole = (options: Options<DeleteUserRoleData>) => {
  return (options?.client ?? client).delete<
    DeleteUserRoleResponse,
    DeleteUserRoleError
  >({
    ...options,
    url: '/users/tid/{uuid}/roles',
  });
};

/**
 * Get Bulk Users By TidUuid
 * Get bulk user details by uuid
 */
export const getBulkUsersByUuid = (
  options: Options<GetBulkUsersByUuidData>
) => {
  return (options?.client ?? client).post<
    GetBulkUsersByUuidResponse,
    GetBulkUsersByUuidError
  >({
    ...options,
    url: '/users/tid/bulk',
  });
};

/**
 * Get Bulk Users By Email
 * Get bulk user details by email. Accessible only in the application context for clients with **App Admin** role.
 */
export const getBulkUsersByEmail = (
  options: Options<GetBulkUsersByEmailData>
) => {
  return (options?.client ?? client).post<
    GetBulkUsersByEmailResponse,
    GetBulkUsersByEmailError
  >({
    ...options,
    url: '/users/email/bulk',
  });
};

/**
 * Get Bulk Users By UserId
 * Get user details in bulk by id or Tiduuid
 */
export const getBulkUsers = (options: Options<GetBulkUsersData>) => {
  return (options?.client ?? client).post<
    GetBulkUsersResponse,
    GetBulkUsersError
  >({
    ...options,
    url: '/users/bulk',
  });
};

/**
 * Get User External References
 * Get user external references based on trn and key
 */
export const getUserExternalReferences = (
  options: Options<GetUserExternalReferencesData>
) => {
  return (options?.client ?? client).get<
    GetUserExternalReferencesResponse,
    GetUserExternalReferencesError
  >({
    ...options,
    url: '/users/{userTrnId}/externalrefs/{key}',
  });
};

/**
 * Delete User External References
 * Delete specific key in the external reference for the given trn
 */
export const deleteUserExternalReferences = (
  options: Options<DeleteUserExternalReferencesData>
) => {
  return (options?.client ?? client).delete<
    DeleteUserExternalReferencesResponse,
    DeleteUserExternalReferencesError
  >({
    ...options,
    url: '/users/{userTrnId}/externalrefs/{key}',
  });
};

/**
 * Get User Preference
 * Get user preferences by id
 */
export const getUserPreference = (options: Options<GetUserPreferenceData>) => {
  return (options?.client ?? client).get<
    GetUserPreferenceResponse,
    GetUserPreferenceError
  >({
    ...options,
    url: '/users/{userId}/preferences',
  });
};

/**
 * Get User image from ProfileX
 * Fetch the information about image (including the URL) from ProfileX for a given user. Accessible only in the application context for clients with **App Admin** role.
 */
export const getUserImage = (options: Options<GetUserImageData>) => {
  return (options?.client ?? client).get<
    GetUserImageResponse,
    GetUserImageError
  >({
    ...options,
    url: '/users/{tidUuid}/image',
  });
};

/**
 * Get User Details by trn
 * Get user details by trn
 */
export const getUserByTrn = (options: Options<GetUserByTrnData>) => {
  return (options?.client ?? client).get<
    GetUserByTrnResponse,
    GetUserByTrnError
  >({
    ...options,
    url: '/users/trn/{trn}',
  });
};

/**
 * Get User External References
 * Get user External References based on key
 */
export const getUserExternalReferences1 = (
  options: Options<GetUserExternalReferences1Data>
) => {
  return (options?.client ?? client).get<
    GetUserExternalReferences1Response,
    GetUserExternalReferences1Error
  >({
    ...options,
    url: '/users/me/externalrefs/{key}',
  });
};

/**
 * Delete User External References
 * Delete specific key in the external reference for the current user
 */
export const deleteUserMeExternalReferences = (
  options: Options<DeleteUserMeExternalReferencesData>
) => {
  return (options?.client ?? client).delete<
    DeleteUserMeExternalReferencesResponse,
    DeleteUserMeExternalReferencesError
  >({
    ...options,
    url: '/users/me/externalrefs/{key}',
  });
};

/**
 * Get User by uuid or email
 * Get user details by uuid or email
 */
export const getUserByUuidOrEmail = (
  options?: Options<GetUserByUuidOrEmailData>
) => {
  return (options?.client ?? client).get<
    GetUserByUuidOrEmailResponse,
    GetUserByUuidOrEmailError
  >({
    ...options,
    url: '/users/identity',
  });
};
